import { useState, useEffect } from 'react';
import appLogo from '/applogo.svg';

interface NavbarProps {
  /**
   * Custom logo URL (optional)
   * If provided, this will be used instead of the default WithinEHR logo
   * Falls back to default logo if not provided or if image fails to load
   */
  logoUrl?: string | null;
}

export const Navbar = ({ logoUrl }: NavbarProps) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoError, setLogoError] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Reset logo error when logoUrl changes
  useEffect(() => {
    setLogoError(false);
  }, [logoUrl]);

  // Determine which logo to use (custom if provided and no error, otherwise default)
  const logoSrc = logoUrl && !logoError ? logoUrl : appLogo;
  const logoAlt = logoUrl && !logoError ? 'Practice Logo' : 'Withinehr Logo';

  return (
    <header
      className={`ww-max-w-7xl ww-mx-auto ww-rounded-lg md:ww-rounded-full ${isScrolled ? 'ww-top-0 md:ww-top-4' : 'ww-top-4'} ww-fixed ww-left-0 ww-right-0 ww-z-50 ww-transition-all ww-duration-300 ${
        isScrolled
          ? 'ww-bg-white ww-backdrop-blur-xl ww-shadow-lg'
          : 'ww-bg-white/50 ww-backdrop-blur-sm'
      }`}
    >
      <div className="ww-container ww-mx-auto ww-px-4 sm:ww-px-8">
        <div className="ww-flex ww-items-center ww-justify-start ww-h-20">
          <div className="ww-flex-shrink-0">
            <a href="/" className="ww-cursor-pointer ww-block">
              <img
                src={logoSrc}
                width={59}
                height={43}
                alt={logoAlt}
                className="ww-block"
                onError={() => {
                  // Fallback to default logo if custom logo fails to load
                  if (logoUrl && !logoError) {
                    console.warn('Failed to load custom logo, falling back to default logo');
                    setLogoError(true);
                  }
                }}
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
